import type { AnswerValue, SurveyAnswers } from '../submitSurvey/types';

/** Structured metadata passed to SDK console log helpers. */
export type SdkLogMetadata = Record<string, unknown> | object;

/** Standard error payload for SDK log helpers (Error instances or message strings). */
export type SdkLoggableError = Error | string;

/** Before/after pair when a respondent changes an answer after navigating back. */
export type AnswerChangeDelta = {
  oldValue: AnswerValue | null;
  newValue: AnswerValue | null;
};

/** Per-question answer diffs detected on backtrack revisit. */
export type BacktrackChangedAnswers = Record<string, AnswerChangeDelta>;

/** Snapshot of page answers stored when the user navigates back. */
export type BacktrackAnswersSnapshot = Partial<SurveyAnswers>;

export function getErrorMessage(err: unknown): string {
  return err instanceof Error ? err.message : String(err);
}

/** Normalizes catch-boundary values into {@link SdkLoggableError}. */
export function toSdkLoggableError(err: unknown): SdkLoggableError {
  return err instanceof Error ? err : String(err);
}
